import { InjectionToken, inject } from '@angular/core';
import { TaskQueueStorageService } from './task-queue-storage.service';
import { ActivityAssociation } from '@vendasta/crm';

export interface Task {
  id: string;
  namespace: string;
}

export interface TaskQueueInterface {
  current: number;
  tasks: Task[];
}

export interface AssociationWithName {
  name: string;
  association: ActivityAssociation;
}

export interface TaskQueueStorageServiceInterface {
  load(): Promise<TaskQueueInterface | null>;
  save(taskQueue: TaskQueueInterface): Promise<void>;
  empty(): Promise<void>;
}

export const TaskQueueStorageServiceInterface = new InjectionToken<TaskQueueStorageServiceInterface>(
  'TaskQueueStorageServiceInterface',
  {
    providedIn: 'root',
    factory: () => inject(TaskQueueStorageService),
  },
);
